<template>
	    <div id="page404">
	    	<div class="Imgss">
			    <img src="../assets/img/404.jpg">
			    <a href="/" style="color: #C32A1A;">返回首页</a>
	    	</div>
	   </div>
	    	
</template>

<script>
    export default {
        name: 'page404',
        data() {
          return {
            errMsg: '抱歉，没有找到你需要的页面！'
          };
        },
        created(){
        	
        },
        methods:{

        }
    }
</script>

<style scoped>
#page404{
	width: 100%;
}
.Imgss img{
	display: block;
	margin:0 auto;
	position:relative;
}
.Imgss a{
	font-size:19px;
	position:relative;
	bottom:20px;
	left:48.5%;
	
}
</style>
